module.exports = __webpack_public_path__ + "img/@culture_img_00_m.043adc1e.jpg";